import { Component, EventEmitter, Input, Output, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { CotStatus } from '../../shared/models/workflow-model/workflow.model';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltipModule } from '@angular/material/tooltip';

@Component({
  selector: 'app-change-ticket-status',
  templateUrl: './change-ticket-status.component.html',
  styleUrl: './change-ticket-status.component.scss',
  standalone: true,
  imports: [CommonModule, MatIconModule, MatButtonModule, TranslateModule, MatTooltipModule],
})
export class ChangeTicketStatusComponent implements OnInit {
  @Input() phase: CotStatus[] = [];
  @Input() statusSelected = 0;
  @Input() expansion = false;
  @Output() emitExpansion = new EventEmitter<boolean>();
  @Output() back = new EventEmitter<boolean>();
  @Output() emitIndex = new EventEmitter<{
    description: string;
    icon: string;
    CctStatus: CotStatus;
    status: number;
  }>();
  public statusButtons: {
    description: string;
    icon: string;
    CctStatus: CotStatus;
    status: number; // 1 Cerrar, 2 Cancelar, 3 Regrewsar, 4 Avanzar
    tolltip: string;
  }[] = [];

  ngOnInit() {
    this.statusButtons = [
      // {
      //   description: 'Cerrar',
      //   icon: 'close',
      //   CctStatus: this.phase[this.statusSelected],
      //   status: 1,
      // },
      {
        description: 'Cancelar',
        icon: 'close',
        CctStatus: this.phase[this.statusSelected],
        status: 2,
        tolltip: 'workflow.cancel',
      },
      {
        description: this.phase[this.statusSelected - 1]
          ? this.phase[this.statusSelected - 1].descripcion
          : '',
        icon: 'arrow_back_ios_new',
        CctStatus: this.phase[this.statusSelected - 1],
        status: 3,
        tolltip: 'workflow.return',
      },
      {
        description: this.phase[this.statusSelected + 1]
          ? this.phase[this.statusSelected + 1].descripcion
          : '',
        icon: 'arrow_forward_ios',
        CctStatus: this.phase[this.statusSelected + 1],
        status: 4,
        tolltip: 'workflow.advance',
      },
    ];
  }

  public indexSelect(index: number): void {
    this.emitIndex.emit(this.statusButtons[index]);
  }
}
